export const DISABLED_SURFACE_BLUR =
  "opacity-90 blur-[1px] transition duration-200 ease-out";

export function blurWhen(disabled: boolean): string {
  return disabled ? DISABLED_SURFACE_BLUR : "";
}
